import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../../../../UserContext";
import MosaicQualify from "../MosaicQualify";
import GoodLeapQualify from "../GoodLeapQualify";
import UpdateCust from "../UpdateCust";
import SungageQualify from "../SungageQualify";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import "../../styles/FinancingMenu.sass";
import ProductsPopup from "./ProductsPopup";
import OffersProvider from "../../hooks/contexts/offers-hook";
import auroraApi from "../../../../api/aurora-api";

import {
  postShareLoanApplication,
  postSubmitChangeOrder,
} from "../../dtos/goodleap";
import LoanApplyModal from "../Modals/LoanApplyModal.jsx";
import LightReachApplyModal from "../Modals/LightReachApplyModal.jsx";
import UploadDocumentsModal from "../Modals/UploadDocumentsModal.jsx";
import IdentityVerificationModal from "../Modals/IdentityVerificationModal.jsx";
import ErrorModal from "../Modals/ErrorModal";
import ShareLoanProvider from "../../hooks/contexts/share-loan-hooks";
import { postLightReachShareLoanApplication, sendLightReachContract, getLightReachTpoOffers, checkLightReachCustomerStatus } from "../../dtos/lightreach";
import { resendTpoDocs } from "../../dtos/goodleap";
import AuthGroupWrapper from "../../../Auth/AuthGroupWrapper";
import { CircularProgress } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import ResendDocsProvider from "../../hooks/contexts/resend-docs-hooks";
import ResendDocsButton from "../ResendDocsButton";

const FinancingMenu = ({
  // State-related Props
  needToResyncTpoPricing,
  setNeedToResyncTpoPricing,
  activeUser,
  qualify,
  sungageView,
  goodLeapView,
  custView,
  mod,
  viewOptions,
  checkmark,
  townhome,
  sungageApplication,
  ppw,
  selectedPpw,
  netPpw,
  grossPpw,
  dealerFee,
  adderTotal,
  ppaEligibleAdderTotal,
  isUsingOldPayscale,
  convertToCashPpw,

  // Inverter Information
  inverter, // { model, type } 

  // Customer Information
  customer, // { projectID, email, repEmail, name }

  // Loan and Financing Details
  loanA,
  loanB,
  bundleId,
  currentProp, // { financingAmount }

  // Address Information
  phone,
  street,
  city,
  state,
  zip,
  stateAbbr,

  // Update and Callback Functions
  setQualify,
  setGoodLeap,
  setSungageView,
  setUpdateCustomer,
  updateCustomer,
  getCustomer,
  setViewApps,
  viewApps,
  setAgreed,
  setCustView,
  setAustinRebate,
  setPricingDisclosures,

  // Disclosures and Tokens
  disclosures,
  disclosureToken,

  // Pricing and Loan Configuration
  setLoanAId,
  setLoanBId,
  setPpw,

  // Utility and Team Information
  team,
  proposal,
  custUtility,

  // Other Flags and States
  agreed,
  primaryContact,
  isCash,
  austinRebate,
  loading,
  mappedPrices,
  mappedLoans,
  mappedLoans2,
  allLoans,
  // loanProducts2,
  loanAmount,
  goodLeapApplications,
  creditCheck,
  createLightReachAcct,
  adderToggle,
  msp = { msp },
  mosaicApi,
  goodLeapApi: goodLeapApi2,
  setSungageApplication,
  panelAmount,
  systemSize,
  batteryAmount,
  battery10,
  acCoupled,
  acCoupledAmount,
  calculateBatteryCost,
  systemCost,
  estimatedAnnualProduction,
  reRoof,
  reRoofAmount,
  downPayment,
  rebate,
  recValue,
  customerData,
  mspForLightReachGetQuote,
  isSigned,
  setCustomer,
  expansionPack,
  expansionPackAmount,
  setDealerFee,
  fetchSungagePayments,
  createUpdatedProposal,
}) => {
  let providers = [];
  let providers2 = [];
  const TPOProviders = ["GoodLeap PPA"];
  const TPOProviders2 = ["GoodLeap PPA"];
  const seen = new Set(TPOProviders);
  const seen2 = new Set(TPOProviders2);
  let types = ["Loan", "TPO", "Cash"];
  let types2 = ["Loan", "TPO", "Cash"];
  let tempTypes = [];
  let tempTypes2 = [];
  const [option1Type, setOption1Type] = useState("");
  const [provider, setProvider] = useState("");
  const [option2Type, setOption2Type] = useState("");
  const [provider2, setProvider2] = useState("");
  const [showLoanApplyModal, setShowLoanApplyModal] = useState(false);
  const [applied, setApplied] = useState(false);
  const [lightReachStatus, setLightReachStatus] = useState(null);
  const [lightReachFiles, setLightReachFiles] = useState(null);
  const [lightReachIdentity, setLightReachIdentity] = useState(null);
  const [lightReachTitle, setLightReachTitle] = useState(null);
  const [sendContractLoading, setSendContractLoading] = useState(false);
  const [sendContractMessage, setSendContractMessage] = useState(null);
  const [sendContractErrorMessage, setSendContractErrorMessage] = useState(null);
  const [refreshStatusLoading, setRefreshStatusLoading] = useState(false);
  const [offersLoading, setOffersLoading] = useState(false);
  const [showUploadDocumentsModal, setShowUploadDocumentsModal] = useState(false);
  const [showIdentityVerificationModal, setShowIdentityVerificationModal] = useState(false);
  const [enfinApplyLoading, setEnfinApplyLoading] = useState(false);

  const { userGroups } = useContext(UserContext) || {};
  /** Roles that are not blocked by the $2.40 net PPW minimum (Sales-Rep-only gate). */
  const GROUPS_THAT_BYPASS_PPW_MINIMUM = [
    "Proposals",
    "Ops",
    "Sales-Support",
    "Super-Admin",
    "Admin",
  ];
  const groupsLoaded = Array.isArray(userGroups);
  const cognitoGroups = groupsLoaded ? userGroups : [];
  const isSalesRep = cognitoGroups.includes("Sales-Rep");
  const bypassesPpwMinimum = cognitoGroups.some((g) =>
    GROUPS_THAT_BYPASS_PPW_MINIMUM.includes(g),
  );
  /**
   * Until Cognito groups load, keep prior behavior (block when net PPW < $2.40).
   * After load: only Sales-Reps who lack any bypass role are blocked.
   */
  const ppwBlocksTpoApplyActions = !groupsLoaded
    ? netPpw < 2.4
    : netPpw < 2.4 && isSalesRep && !bypassesPpwMinimum;
  const tpoApplyButtonEnabled =
    !ppwBlocksTpoApplyActions && !needToResyncTpoPricing;
  const providerLower = provider?.toLowerCase() || "";
  const isEnFinTpo = option1Type === "TPO" && providerLower.includes("enfin");

  const customerAddress = street + " " + city + ", " + state + " " + zip;

  useEffect(() => {
    if (!provider?.toLowerCase()?.includes("lightreach")) {
      setLightReachStatus(null);
      setLightReachFiles(null);
      setLightReachIdentity(null);
      setLightReachTitle(null);
      setSendContractMessage(null);
      setSendContractErrorMessage(null);
      setOffersLoading(false);
    } else {
      setOffersLoading(true);
    }
  }, [provider]);

  useEffect((f) => f, [batteryAmount]);

  let batteryCost = batteryAmount;
  const sfProjectId = customer.projectID;

  const offersPayload = {
    state: stateAbbr.usps,
    utility: custUtility,
    hasBattery: customerData.battery10 >= 11 && customerData.battery10 < 20,
    lightReachAcctId: customer.lightReachAccountId,
    sfProjectId: customer.projectID,
  };

  const handleCloseLoanApplyModal = () => {
    setShowLoanApplyModal(false);
    if (provider?.toLowerCase()?.includes("lightreach")) {
      const battery10 = customerData?.battery10 ?? 0;
      const expansionPackNum = Number(expansionPack) || 0;
      const expansionPackAmt = Number(expansionPackAmount) || 0;
      const batteryCount =
        battery10 <= 10
          ? battery10 + expansionPackNum
          : battery10 > 10 && battery10 < 20
            ? battery10 - 10 + expansionPackNum
            : battery10 - 20 + expansionPackNum;
      const payload = {
        sfProjectId: customer.projectID,
        hasBattery: offersPayload.hasBattery,
        msp: mspForLightReachGetQuote,
        batteryCost: batteryAmount + expansionPackAmt * expansionPackNum,
        batteryCount,
      };
      getLightReachTpoOffers(payload)
        .then((response) => {
          if (response?.status != null) {
            setLightReachStatus(response.status);
          }
          if (response?.files != null) {
            setLightReachFiles(response.files);
          }
          if (response?.identity != null) {
            setLightReachIdentity(response.identity);
          }
          if (response?.title != null) {
            setLightReachTitle(response.title);
          }
        })
        .catch(() => {});
    }
  };

  const refreshLightReachStatus = async () => {
    if (!provider?.toLowerCase()?.includes("lightreach")) return;
    const acctId = customer.lightReachAccountId;
    if (!acctId) return;
    setRefreshStatusLoading(true);
    try {
      const response = await checkLightReachCustomerStatus(acctId);
      if (response?.status != null) {
        setLightReachStatus(response.status);
      }
      if (response?.files != null) {
        setLightReachFiles(response.files);
      }
      if (response?.identity != null) {
        setLightReachIdentity(response.identity);
      }
      if (response?.title != null) {
        setLightReachTitle(response.title);
      }
    } catch (_) {
      // ignore
    } finally {
      setRefreshStatusLoading(false);
    }
  };

  const shareLoanPayload =
    option1Type === "TPO" && providerLower.includes("goodleap")
      ? {
        firstName: primaryContact.firstName,
        lastName: primaryContact.lastName,
        email: customer.email,
        state: stateAbbr.usps,
        offerId: loanA.offerId,
        submittingUser_firstName: activeUser.attributes.given_name,
        submittingUser_lastName: activeUser.attributes.family_name,
        submittingUser_email: activeUser.attributes.email,
        loanAmount: loanA.totalAmount,
        powerPurchaseRate: loanA.ppaRate,
        firstYearProduction: estimatedAnnualProduction,
        systemSize: systemSize / 1000,
        sfProjectId: customer.projectID,
        sfProjectName: customer.name,
        proposalId: proposal.propId,
        addressString: customerAddress,
        escalator: loanA.ppaEscalator,
        monthlyPayment: loanA.firstMonthPayment,
        sendEmail: false,
        batteryCost: acCoupled
          ? acCoupledAmount + batteryAmount
          : batteryAmount,
        battery10: customerData.battery10,
        hasMSP: Boolean(msp),
        utilityRate: loanA.firstMonthPayment
      }
      : {
        sfProjectId: customer.projectID,
        link: `https://sabal.palmetto.com/accounts/${customer.lightReachAccountId}/application/create`,
      };

  //Setup Option 1
  providers = [];

  allLoans.forEach((loan) => {
    const firstWord = loan.loanName;
    if (!seen.has(firstWord) && firstWord !== "Owner Financing") {
      if (+loan.isPpa === 0) {
        providers.push(firstWord.split(" ")[0]);
        if (!tempTypes.includes("Loan")) {
          tempTypes.push("Loan");
        }
      } else if (
        +loan.isPpa === 1 &&
        firstWord !== "GoodLeap Lease" &&
        firstWord
      ) {
        TPOProviders.push(firstWord);
        if (!tempTypes.includes("TPO")) {
          tempTypes.push("TPO");
        }
      }
      seen.add(firstWord);
    } else if (!seen.has(firstWord) && firstWord === "Owner Financing") {
      if (!tempTypes.includes("Cash")) {
        tempTypes.push("Cash");
      }
    }
  });

  types = tempTypes;

  if (option1Type === "") {
    const loanAProvider = loanA.loanName.split(" ")[0];
    if (loanAProvider === "Owner") {
      setOption1Type("Cash");
      setProvider("Cash");
    } else if (+loanA.isPpa === 1) {
      setOption1Type("TPO");
      setProvider(loanAProvider);
    } else {
      setOption1Type("Loan");
      setProvider(loanAProvider);
    }
  }

  if (option1Type === "Loan") {
    // Already set
  } else if (option1Type === "TPO") {
    providers = TPOProviders;
  } else if (option1Type === "Cash") {
    //remove all other providers and push cash
    providers = [];
    providers.push("Cash");
  }

  //Setup Option 2
  providers2 = [];
  allLoans.forEach((loan) => {
    const firstWord = loan.loanName;
    if (!seen2.has(firstWord) && firstWord !== "Owner Financing") {
      if (+loan.isPpa === 0) {
        providers2.push(firstWord.split(" ")[0]);
        if (!tempTypes2.includes("Loan")) {
          tempTypes2.push("Loan");
        }
      } else if (
        +loan.isPpa === 1 &&
        firstWord !== "GoodLeap Lease" &&
        firstWord
      ) {
        TPOProviders2.push(firstWord);
        if (!tempTypes2.includes("TPO")) {
          tempTypes2.push("TPO");
        }
      }
      seen2.add(firstWord);
    } else if (!seen2.has(firstWord) && firstWord === "Owner Financing") {
      if (!tempTypes2.includes("Cash")) {
        tempTypes2.push("Cash");
      }
    }
  });

  types2 = tempTypes2;

  if (option2Type === "") {
    const loanBProvider = loanB.loanName.split(" ")[0];
    if (loanBProvider === "Owner") {
      setOption2Type("Cash");
      setProvider2("Cash");
    } else if (+loanB.isPpa === 1) {
      setOption2Type("TPO");
      setProvider2(loanBProvider);
    } else {
      setOption2Type("Loan");
      setProvider2(loanBProvider);
    }
  }

  if (option2Type === "Loan") {
    // Already set
  } else if (option2Type === "TPO") {
    providers2 = TPOProviders2;
  } else if (option2Type === "Cash") {
    //remove all other providers and push cash
    providers2 = [];
    providers2.push("Cash");
  }

  useEffect(() => {
    if (option1Type === "Cash") {
      setProvider("Cash");
      setLoanAId(115);
      setPpw(+ppw * dealerFee || 3.8, true);
    }
  }, [option1Type]);

  const setLightReachAcctId = (lrAcctId) => {
    customer.lightReachAccountId = lrAcctId;
    setCustomer(customer);
  };

  const openEnfinApplyLink = async () => {
    if (!customer?.projectID || enfinApplyLoading) return;
    setEnfinApplyLoading(true);
    try {
      const response = await auroraApi.getEnfinApplyLink({
        projectId: customer.projectID,
      });
      if (response?.data) {
        window.open(response.data, "_blank", "noopener,noreferrer");
      }
    } catch (error) {
      console.error("Failed to fetch EnFin apply link:", error);
    } finally {
      setEnfinApplyLoading(false);
    }
  };

  return loading ? (
    <CircularProgress size={30} color="inherit" />
  ) : (
    <>
      {sungageView ? (
        <SungageQualify
          invModel={proposal.invModel}
          invType={proposal.invType}
          mod={mod}
          projectId={customer.projectID}
          agreed={agreed}
          bundleId={bundleId}
          disclosures={disclosures}
          name={customer.name}
          email={customer.email}
          repEmail={customer.repEmail}
          customer={customer}
          phone={phone}
          street={street}
          city={city}
          state={state}
          zip={zip}
          getCustomer={getCustomer}
          setUpdateCustomer={setUpdateCustomer}
          updateCustomer={updateCustomer}
          setSungageView={setSungageView}
          sungageApplication={sungageApplication}
          viewApps={viewApps}
          setViewApps={setViewApps}
          financingAmount={currentProp.financingAmount}
          disclosureToken={disclosureToken}
          loanA={loanA}
          loanAmount={loanAmount}
          goodLeapApplications={goodLeapApplications}
          proposal={proposal}
          setSungageApplication={setSungageApplication}
          panelAmount={panelAmount}
          systemSize={systemSize}
          reRoof={reRoof}
          reRoofAmount={reRoofAmount}
          batteryCost={batteryAmount}
          systemCost={systemCost}
          downPayment={downPayment}
          activeUser={activeUser}
          recValue={recValue}
          rebate={rebate}
        />
      ) : qualify ? (
        <MosaicQualify
          invModel={inverter.model}
          invType={inverter.type}
          mod={mod}
          projectId={customer.projectID}
          agreed={agreed}
          setAgreed={setAgreed}
          bundleId={bundleId}
          disclosures={disclosures}
          name={customer.name}
          projectID={customer.projectID}
          email={customer.email}
          repEmail={customer.repEmail}
          phone={phone}
          street={street}
          city={city}
          state={state}
          zip={zip}
          getCustomer={getCustomer}
          setUpdateCustomer={setUpdateCustomer}
          updateCustomer={updateCustomer}
          setQualify={setQualify}
          viewApps={viewApps}
          setViewApps={setViewApps}
          financingAmount={currentProp.financingAmount}
        />
      ) : goodLeapView ? (
        <GoodLeapQualify
          invModel={proposal.invModel}
          invType={proposal.invType}
          mod={mod}
          projectId={customer.projectID}
          agreed={agreed}
          bundleId={bundleId}
          disclosures={disclosures}
          name={customer.name}
          email={customer.email}
          repEmail={customer.repEmail}
          customer={customer}
          phone={phone}
          street={street}
          city={city}
          state={state}
          zip={zip}
          getCustomer={getCustomer}
          setUpdateCustomer={setUpdateCustomer}
          updateCustomer={updateCustomer}
          setGoodLeap={setGoodLeap}
          viewApps={viewApps}
          setViewApps={setViewApps}
          financingAmount={currentProp.financingAmount}
          disclosureToken={disclosureToken}
          loanA={loanA}
          loanAmount={loanAmount}
          goodLeapApplications={goodLeapApplications}
        />
      ) : custView > 0 ? (
        <>
          {/* <div className="container"> */}
          <UpdateCust
            primaryContact={primaryContact}
            name={customer.name}
            projectID={customer.projectID}
            email={customer.email}
            phone={phone}
            street={street}
            city={city}
            state={state}
            zip={zip}
            getCustomer={getCustomer}
            setUpdateCustomer={setUpdateCustomer}
            updateCustomer={updateCustomer}
            custView={custView}
            setCustView={setCustView}
            creditCheck={creditCheck}
          />
          {/* </div> */}
        </>
      ) : (
        <div>
          <div className="row">
            <h3 className="menuFont">Financing</h3>
          </div>
          <div className="custContainer menu">
            <div className="row">
              <div className="menuBorder"></div>
            </div>
            <div className="row">
              <div
                className="col-sm"
                style={{ maxHeight: "480px", overflowY: "auto" }}
              >
                <div className="savingsText modals fin">Option 1</div>
                <ButtonGroup>
                  {types.map((opt) => (
                    <Button
                      key={opt}
                      variant="secondary"
                      className={
                        option1Type === opt
                          ? "financeGroupButton selected"
                          : "financeGroupButton notselected"
                      }
                      onClick={() => setOption1Type(opt)}
                    >
                      {opt}
                    </Button>
                  ))}
                </ButtonGroup>

                <div className="savingsText modals fin">Provider</div>
                <ButtonGroup>
                  {providers.map((opt) => (
                    <Button
                      key={opt}
                      variant="secondary"
                      className={
                        provider.split(" ")[0]?.toLowerCase() ===
                          opt.split(" ")[0]?.toLowerCase()
                          ? "financeGroupButton selected"
                          : "financeGroupButton notselected"
                      }
                      onClick={() => setProvider(opt)}
                    >
                      {opt.split(" ")[0]}
                    </Button>
                  ))}
                </ButtonGroup>
                {option1Type === "Cash" && (
                  <>
                    <div className="savingsText modals fin">Pricing</div>
                    <select
                      className="finInput prices"
                      onChange={(e) => setPpw(+e.target.value, false)}
                    >
                      {mappedPrices}
                    </select>
                  </>
                )}
                {provider && !isEnFinTpo && (
                  <OffersProvider
                    setDisclosures={setPricingDisclosures}
                    onLoadingChange={setOffersLoading}
                  >
                    <ProductsPopup
                      setNeedToResyncTpoPricing={setNeedToResyncTpoPricing}
                      mappedPrices={mappedPrices}
                      mappedLoans={mappedLoans}
                      setPpw={setPpw}
                      loanList={allLoans}
                      customerData={customerData}
                      mspForLightReachGetQuote={mspForLightReachGetQuote}
                      setLoanAId={setLoanAId}
                      estimatedAnnualProduction={estimatedAnnualProduction}
                      systemSize={systemSize / 1000}
                      optionType={option1Type}
                      payload={offersPayload}
                      ppw={ppw}
                      adderTotal={adderTotal}
                      loan={loanA}
                      provider={provider}
                      batteryCost={batteryAmount}
                      acCoupled={acCoupled}
                      acCoupledAmount={acCoupledAmount}
                      sfProjectId={sfProjectId}
                      lightReachAcctId={customer.lightReachAccountId}
                      setLightReachAcctId={setLightReachAcctId}
                      dealerFee={dealerFee}
                      fetchSungagePayments={fetchSungagePayments}
                      setDealerFee={setDealerFee}
                      expansionPack={expansionPack}
                      expansionPackAmount={expansionPackAmount}
                      battery10={battery10}
                      calculateBatteryCost={calculateBatteryCost}
                      setLightReachStatus={setLightReachStatus}
                      setLightReachIdentity={setLightReachIdentity}
                      setLightReachTitle={setLightReachTitle}
                    />
                  </OffersProvider>
                )}
              </div>
              <div className="col">
                {isEnFinTpo ? (
                  <div className="enfin-apply-wrap mt-3">
                    <p className="small text-start mb-2" style={{ lineHeight: 1.45 }}>
                      To use Enfin as a finance provider you will need to open Aurora
                      and do the following:
                    </p>
                    <ul
                      className="small text-start mb-3 ps-3"
                      style={{ lineHeight: 1.5 }}
                    >
                      <li>In design mode, highlight all the modules</li>
                      <li>Delete existing modules and the inverter</li>
                      <li>
                        Use Auto Designer or manually place new &quot;Q.PEAK DUO BLK
                        ML-G10.C1+/AC 410&quot; modules
                      </li>
                      <li>Simulate Production</li>
                      <li>Navigate to Sales Mode (Monitor icon in top right)</li>
                      <li>Navigate to Financing ($ icon in top middle)</li>
                      <li>
                        Select Enfin as the source, and the product you want to sell
                      </li>
                      <li>
                        After completing the credit app and signing docs, Send CIA
                        button will be unlocked
                      </li>
                      <li>
                        Once CIA is signed, you can schedule a site survey through
                        Proposalist
                      </li>
                    </ul>
                    <button
                      className="custButton confirm apply"
                      type="button"
                      onClick={openEnfinApplyLink}
                      disabled={enfinApplyLoading}
                    >
                      {enfinApplyLoading ? "Loading..." : "Apply Through Aurora"}
                    </button>
                  </div>
                ) : (
                  <>
                {!isUsingOldPayscale() && (!needToResyncTpoPricing || option1Type !== "TPO") && (
                  <div className="col" style={{ maxHeight: "480px" }}>
                    {provider !== "Cash" && (
                      <div className="row mt-2">
                        <div className="col-md-6">
                          <div className="savingsText modals fin">
                            Total Amount:
                          </div>
                          <div className="text-left">
                            $
                            {(
                              loanA?.totalAmount ||
                              loanAmount ||
                              0
                            )?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="savingsText modals fin">
                            Monthly Payment:
                          </div>
                          <div className="text-left">
                            $
                            {(
                              loanA?.firstMonthPayment ||
                              loanA.prePayment * loanAmount ||
                              0
                            )?.toFixed(2)}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <div className="savingsText modals fin">Gross PPW:</div>
                        <div className="text-left">
                          ${Number(grossPpw || 0).toFixed(2)}
                        </div>
                      </div>
                      {netPpw !== 0 && netPpw !== null && (
                        <div className="col-md-6">
                          <div className="savingsText modals fin">Net PPW:</div>
                          <div className="text-left">
                            ${Number(netPpw || 0).toFixed(2)}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <div className="savingsText modals fin">
                          System Size:
                        </div>
                        <div className="text-left">
                          {(systemSize / 1000).toFixed(2)} kW
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="savingsText modals fin">
                          Selected PPW:
                        </div>
                        <div className="text-left">
                          ${(ppw * dealerFee).toFixed(2)}
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-md-6">
                        <div className="savingsText modals fin">Adders:</div>
                        <div className="text-left">
                          ${(adderTotal * dealerFee).toFixed(0)}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="savingsText modals fin">
                          Dealer Fee:
                        </div>
                        <div className="text-left">
                          {((1 - dealerFee) * 100).toFixed(0)}%
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div>
                  {loanA.loanName === "Mosaic" && (
                    <button
                      className="custButton confirm apply"
                      onClick={() => {
                        createUpdatedProposal();
                        setQualify(true);
                        mosaicApi("disclosures");
                      }}
                    >
                      Apply
                    </button>
                  )}
                  {+loanA.isPpa === 1 && option1Type === "TPO" && !isEnFinTpo && (
                    <AuthGroupWrapper
                      requiredGroups={[
                        "Proposals",
                        "Ops",
                        "Sales-Support",
                        "Sales-Rep",
                        "Super-Admin",
                        "Admin",
                      ]}
                    >
                      <button
                        className={tpoApplyButtonEnabled ? "custButton confirm apply" : "custButton apply disabled"}
                        disabled={!tpoApplyButtonEnabled}
                        onClick={() => {
                          createUpdatedProposal();
                          setShowLoanApplyModal(true);
                        }}
                      >
                        {!(
                          option1Type === "TPO" &&
                          providerLower.includes("lightreach")
                        ) &&
                          (isSigned || applied)
                          ? `Submit Change Order`
                          : `Apply`}
                      </button>
                      {netPpw < 2.4 && (
                        <div className="col">
                          <div className="qualyText error">*Net PPW must be greater than or equal to $2.40</div>
                        </div>
                      )}
                      {needToResyncTpoPricing && (
                        <div className="col">
                          <div className="qualyText error">*Please re-select pricing from table to proceed with application</div>
                        </div>
                      )}
                      {provider?.toLowerCase()?.includes("lightreach") && (
                        <div className="col-12 mt-2">
                          <button
                            type="button"
                            className={tpoApplyButtonEnabled && !sendContractLoading ? "custButton confirm apply" : "custButton apply disabled"}
                            disabled={!tpoApplyButtonEnabled || sendContractLoading}
                            onClick={async () => {
                              const accountId = customer.lightReachAccountId;
                              if (!accountId) return;
                              setSendContractMessage(null);
                              setSendContractErrorMessage(null);
                              setSendContractLoading(true);
                              try {
                                const response = await sendLightReachContract(accountId, sfProjectId);
                                const success = response?.Success === true || response?.success === true;
                                if (success) {
                                  setSendContractMessage("The contract has been sent.");
                                  refreshLightReachStatus();
                                } else {
                                  setSendContractErrorMessage(response?.message ?? "The request was unsuccessful.");
                                }
                              } catch (err) {
                                setSendContractMessage(err?.message || "Failed to send contract.");
                              } finally {
                                setSendContractLoading(false);
                              }
                            }}
                          >
                            {sendContractLoading ? (
                              <CircularProgress size={24} color="inherit" />
                            ) : lightReachStatus === "6 - Contract Sent" ? (
                              "Resend Contract"
                            ) : (
                              "Send Contract"
                            )}
                          </button>
                          {sendContractMessage && (
                            <div className="savingsText modals fin mt-2" style={{ color: "#000" }}>
                              {sendContractMessage}
                            </div>
                          )}
                          {sendContractErrorMessage && (
                            <ErrorModal
                              errorMessage={sendContractErrorMessage}
                              onHideParent={() => setSendContractErrorMessage(null)}
                            />
                          )}
                        </div>
                      )}
                    </AuthGroupWrapper>
                  )}

                  {option1Type === "Loan" &&
                    ["goodleap"].includes(
                      loanA.loanName.toLocaleLowerCase()
                    ) && (
                      <button
                        className="custButton confirm apply"
                        onClick={() => {
                          createUpdatedProposal();
                          setGoodLeap(true);
                        }}
                      >
                        Apply
                      </button>
                    )}
                  { }
                  {loanA.loanName?.toLocaleLowerCase() === "sungage" && (
                    <button
                      className="custButton confirm apply"
                      onClick={async () => {
                        createUpdatedProposal();
                        setSungageView(true);
                      }}
                    >
                      Apply
                    </button>
                  )}
                  {option1Type === "Loan" &&
                    !["sungage", "mosaic", "goodleap"].includes(
                      loanA.loanName.toLocaleLowerCase()
                    ) &&
                    !isCash && (
                      <button
                        className="custButton confirm apply"
                        onClick={async () => {
                          createUpdatedProposal();
                          setCustView(1);
                        }}
                      >
                        Apply
                      </button>
                    )}
                </div>
                {showLoanApplyModal && provider?.toLowerCase()?.includes("lightreach") && (
                  <LightReachApplyModal
                    show={showLoanApplyModal}
                    onHide={handleCloseLoanApplyModal}
                    firstName={primaryContact?.firstName}
                    email={customer?.email}
                    acctId={customer?.lightReachAccountId}
                    repEmail={activeUser?.attributes?.email}
                  />
                )}
                {showLoanApplyModal && !provider?.toLowerCase()?.includes("lightreach") && !isEnFinTpo && (
                  <ShareLoanProvider
                    payload={shareLoanPayload}
                    shareLoanDTO={
                      isSigned || applied
                        ? postSubmitChangeOrder
                        : option1Type === "TPO" &&
                            providerLower.includes("goodleap")
                            ? postShareLoanApplication
                            : postLightReachShareLoanApplication
                    }
                  >
                    <LoanApplyModal
                      show={showLoanApplyModal}
                      onHide={handleCloseLoanApplyModal}
                      isChangeOrder={isSigned}
                      loanA={loanA}
                      sfProjectId={sfProjectId}
                      applied={applied}
                      setApplied={setApplied}
                    />
                  </ShareLoanProvider>
                )}
                  </>
                )}
              </div>
            </div>
            {provider?.toLowerCase()?.includes("lightreach") && (
              <div
                className="mt-4 rounded p-3"
                style={{
                  border: "1px solid #dee2e6",
                  backgroundColor: "#f8f9fa",
                }}
              >
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3 pb-2" style={{ borderBottom: "1px solid #dee2e6" }}>
                  <span style={{ fontWeight: 600, fontSize: "1rem", color: "#212529" }}>
                    LightReach Application
                  </span>
                  {!offersLoading && (
                    <div className="d-flex flex-wrap gap-2 align-items-center">
                      <Button
                        variant="outline-secondary"
                        size="sm"
                        style={{ backgroundColor: "#fff" }}
                        disabled={refreshStatusLoading}
                        onClick={refreshLightReachStatus}
                        aria-label="Refresh customer info"
                      >
                        {refreshStatusLoading ? (
                          <CircularProgress size={16} color="inherit" className="me-1" />
                        ) : (
                          <RefreshIcon fontSize="small" className="me-1" />
                        )}
                        Refresh Info
                      </Button>
                      <Button
                        variant="primary"
                        size="sm"
                        className="btn-primary btn-sm"
                        onClick={() => setShowIdentityVerificationModal(true)}
                      >
                        Upload Proof of Identity
                      </Button>
                      <Button
                        variant="primary"
                        size="sm"
                        className="btn-primary btn-sm"
                        onClick={() => setShowUploadDocumentsModal(true)}
                      >
                        Upload Documents
                      </Button>
                    </div>
                  )}
                </div>

                {offersLoading ? (
                  <div className="py-3 d-flex align-items-center gap-2">
                    <CircularProgress size={24} />
                    <span className="text-muted small">Loading…</span>
                  </div>
                ) : (
                  <>
                    <div className="row g-3 mb-4">
                      <div className="col-md-4">
                        <div
                          className="rounded p-2 h-100"
                          style={{ backgroundColor: "#fff", border: "1px solid #e9ecef" }}
                        >
                          <div className="small text-muted">Customer Stage</div>
                          <div style={{ fontWeight: 500, color: "#212529" }}>
                            {lightReachStatus ?? "—"}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className="rounded p-2 h-100"
                          style={{ backgroundColor: "#fff", border: "1px solid #e9ecef" }}
                        >
                          <div className="small text-muted">Identity Verification</div>
                          <div style={{ fontWeight: 500, color: "#212529" }}>
                            {lightReachIdentity ?? "Incomplete"}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className="rounded p-2 h-100"
                          style={{ backgroundColor: "#fff", border: "1px solid #e9ecef" }}
                        >
                          <div className="small text-muted">Title Verification</div>
                          <div style={{ fontWeight: 500, color: "#212529" }}>
                            {lightReachTitle ?? "Incomplete"}
                          </div>
                        </div>
                      </div>
                    </div>

                    {lightReachFiles &&
                      (Array.isArray(lightReachFiles)
                        ? lightReachFiles
                        : Object.values(lightReachFiles)
                      ).length > 0 && (
                        <>
                          <div className="small text-muted mb-2">Uploaded Documents</div>
                          <div
                            className="rounded p-2 small"
                            style={{ backgroundColor: "#fff", border: "1px solid #e9ecef" }}
                          >
                            {(Array.isArray(lightReachFiles)
                              ? lightReachFiles
                              : Object.values(lightReachFiles)
                            ).map((group, idx) => {
                              const typeLabel = group?.type ?? "—";
                              const fileList = group?.files
                                ? Array.isArray(group.files)
                                  ? group.files
                                  : Object.values(group.files)
                                : [];
                              return (
                                <div key={idx} className="mb-2">
                                  <span className="text-muted">{typeLabel}:</span>{" "}
                                  {fileList.length > 0
                                    ? fileList.map((f, fidx) => f?.originalName ?? "—").join(", ")
                                    : "—"}
                                </div>
                              );
                            })}
                          </div>
                        </>
                      )}
                  </>
                )}

                <UploadDocumentsModal
                  show={showUploadDocumentsModal}
                  onHide={() => setShowUploadDocumentsModal(false)}
                  acctId={customer?.lightReachAccountId}
                  onUploadSuccess={refreshLightReachStatus}
                />
                <IdentityVerificationModal
                  show={showIdentityVerificationModal}
                  onHide={() => setShowIdentityVerificationModal(false)}
                  acctId={customer?.lightReachAccountId}
                  onUploadSuccess={refreshLightReachStatus}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default FinancingMenu;
